<template>
  <div class="fc-home">
    <div class="contest-wrapper">
      <h1>Contests
        <span class="subcontent">You can edit the contest anytime before it starts.</span>
      </h1>
      <router-link class="create-btn" :to="{name: 'FCCreateContest'}">Create New Contest
      </router-link>
      <loading-state :state="featuredState"></loading-state>
      <div v-if="featuredState.isLoaded()">
        <div class="featured-contests">
          <h3 class="sub-title">Featured Contests</h3>
          <div class="featured-contests-inner" v-if="allFeaturedContests.featured_contests && allFeaturedContests.featured_contests.length > 0">
            <div class="contest-box" v-for="featuredContest in allFeaturedContests.featured_contests" :key="featuredContest.key">
              <div class="contest-box-inner">
                <h3 @click="gotoContest(featuredContest.contest.key)"><span :class="featuredContest.contest.status">{{featuredContest.contest.status}}</span>{{featuredContest.contest.name}}</h3>
                <p>{{featuredContest.contest.desc}}</p>
                <p class="top-space">Rank {{featuredContest.rank}}</p>
                <div>
                  <span class="create-new-rule bottom-sapce" @click="featuredContest.changeRank = !featuredContest.changeRank">CHANGE RANK</span>
                  <div class="top-space" v-if="featuredContest.changeRank">
                    <div class="box">
                      <el-date-picker class="start-date"
                        v-model="featuredContest.online_date"
                        type="date"
                        placeholder="Online date">
                      </el-date-picker>
                      <el-date-picker class="end-date"
                        v-model="featuredContest.offline_date"
                        type="date"
                        placeholder="Offline date">
                      </el-date-picker>
                    </div>
                    <el-input class="rank-input top-space" placeholder="Ex: 1" type="number" v-model="featuredContest.rank"></el-input>
                    <button class="change-btn" @click="addFeatured(featuredContest, 'Edit')">Add</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="error-resp" v-else>No featured contests available</div>
        </div>
      </div>
      <loading-state :state="state"></loading-state>
      <div v-if="state.isLoaded()">
        <div class="recent-contest">
          <h3 class="sub-title">Recent Contests</h3>
          <div v-if="contests.length > 0">
            <div class="contest-box" v-for="contest in contests" :key="contest.key">
              <div class="contest-box-inner">
                <h3 @click="gotoContest(contest.key)"><span :class="contest.status">{{contest.status}}</span>{{contest.name}}</h3>
                <p>{{contest.desc}}</p>
                <div>
                  <span class="create-new-rule bottom-sapce" @click="contest.addToFeature = !contest.addToFeature">Add to feature contest</span>
                  <div class="top-space" v-if="contest['addToFeature']">
                    <div class="box">
                      <el-date-picker class="start-date"
                        v-model="featuredContest.online_date"
                        type="date"
                        placeholder="Online date">
                      </el-date-picker>
                      <el-date-picker class="end-date"
                        v-model="featuredContest.offline_date"
                        type="date"
                        placeholder="Offline date">
                      </el-date-picker>
                    </div>
                    <el-input class="rank-input top-space" placeholder="Give a rank" type="number" v-model="featuredContest.rank"></el-input>
                    <button class="change-btn" @click="addFeatured(contest, 'add')">Add</button>
                  </div>
                </div>
              </div>
            </div>
            <router-link :to="{name: 'AllContests'}" class="change-btn show-all">Show all contests</router-link>
          </div>
          <div class="error-resp" v-else>
            No contests available
          </div>
        </div>
        <div>
          <Pagination @loadContent="loadContent" :pagination="home"></Pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { DataState } from '@/state'
import { UserHome, FeaturedContest } from '@/models/fantasyconsole/contest'
import GamePreview from '@/components/fantasygame/GamePreview'
import ContestGames from '@/components/fantasygame/ContestGames'
import Pagination from '@/components/cricket/Pagination'

export default {
  components: {
    GamePreview,
    ContestGames,
    Pagination
  },
  data () {
    return {
      home: {},
      state: DataState.newLoading(),
      featuredState: DataState.newLoading(),
      contestType: 'All Contests',
      searchContest: null,
      featuredContest: new FeaturedContest(),
      allFeaturedContests: [],
      options: [
        {
          'key': 'All Contests',
          'name': 'All Contests'
        },
        {
          'key': 'Scheduled',
          'name': 'Scheduled'
        }
      ],
      rank: null,
      showRank: false,
      activePage: null,
      limit: 10,
      contests: []
    }
  },

  mounted() {
    UserHome.getHome().then((resp) => {
      if (resp.contests.length > 5) {
        for (let i = 0; i <= 4; i++) {
          this.contests.push(resp.contests[i])
        }
      } else {
        for (let contest of resp.contests) {
          this.contests.push(contest)
        }
      } 
      localStorage.clear()
      this.state.changeToLoaded()
    }).catch((error) => {
      this.state.changeToError(error)
    })
    this.getAllFeatured()
  },
  watch: {
   '$route' (to, from) {
      this.getAllFeatured()
    }
  },
  methods: {
    addFeatured (contest, type) {
      if (contest.key && type === 'Edit') {
        this.featuredContest = new FeaturedContest()
        this.featuredContest.online_date = contest.online_date
        this.featuredContest.offline_date = contest.offline_date
        this.featuredContest.rank = contest.rank
        this.featuredContest.key = contest.key
        this.featuredContest.contest_key = contest.contest.key
      } else {
        this.featuredContest.contest_key = contest.key
      }
      FeaturedContest.featuredContest(this.featuredContest).then((resp) => {
        contest.addToFeature = false
        if (resp) {
          this.getAllFeatured()
        }
        this.$notify({
          title: 'Success',
          message: 'Updated your contest to featured',
          type: 'success'
        })
        this.featuredState.changeToLoaded()
      }).catch((error) => {
        this.featuredState.changeToError(error)
        if (this.featuredState.msg.response.data.error) {
           this.$notify({
            title: 'Error',
            message: this.featuredState.msg.response.data.error.msg,
            type: 'error'
          })
        }
      })
    },
    getAllFeatured () {
      FeaturedContest.getFeaturedContest().then((resp) => {
        this.allFeaturedContests = resp
        this.featuredState.changeToLoaded()
      }).catch((error) => {
        this.featuredState.changeToError(error)
      })
    },
    loadContent (e) {
      UserHome.getHome(e).then((resp) => {
        this.home = resp
        this.state.changeToLoaded()
      }).catch((error) => {
        this.state.changeToError(error)
      })
    },
    gotoContest (key) {
      this.$router.push({ name: 'FCEditContest', params: { 'key':  key } })
    }
  }
}
</script>
<style lang="scss">
  .el-select-dropdown {
    ul li {
      span {
        font-family: "proxima-nova", sans-serif;
        color: #333;
        font-size: 15px;
      }
    }
  }
</style>
